module.exports = __webpack_public_path__ + "images/107_4096.jpg";